import React from "react";
import "./Header.css";
import img from "../../Assets/headerImg.png";

export default function Header() {
  return (
    <div className="headermain">
      <div className="header1">
        <div className="head1-div">
          <p className="headline">
            Hy! I am <br />{" "}
            <span>
              <p className="headlineSpan">Sahil Rohera</p>
            </span>
          </p>

          <p className="headtagline">
            Innovative coder with a vision <br /> for progress{" "}
          </p>
          <div className="btn">
            <a
              style={{ textDecoration: "none", color: "black" }}
              href="mailto:sahilrohera10@gmail.com"
            >
              <p className="btntext"> Hire Me </p>
            </a>
            <div className="btn2"></div>
          </div>
        </div>
      </div>

      <div className="header2">
        <img className="imgclass" src={img} alt="" />
      </div>
    </div>
  );
}
